import { render, staticRenderFns } from "./Categorias-cajas.vue?vue&type=template&id=46ab21f4&scoped=true"
import script from "./Categorias-cajas.vue?vue&type=script&lang=js"
export * from "./Categorias-cajas.vue?vue&type=script&lang=js"
import style0 from "./Categorias-cajas.vue?vue&type=style&index=0&id=46ab21f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46ab21f4",
  null
  
)

export default component.exports